import { firstByClass } from '../first-by-class';
import { getParents } from '../get-parents';

export function getParentWithClass(
	element: HTMLElement,
	className: string
): HTMLElement {
	return firstByClass(getParents(element), className);
}
